import styles from './styles.module.scss';
import illustration from '@svg/illustrations/success_money_add.svg';
import Typography from '@components/common/typography';
import { useTranslation } from 'react-i18next';

const SuccessSection = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'cashback'
    });
    return (
        <div className={styles.success}>
            <img src={illustration} alt="money move success" />
            <div className={styles.title}>Success!</div>
            <Typography variant="body1">{t('success_redeem')}</Typography>
        </div>
    );
};

export default SuccessSection;
